import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 852px;
`;
